import { render, staticRenderFns } from "./VersionBugs.vue?vue&type=template&id=292b52f6&scoped=true&"
import script from "./VersionBugs.vue?vue&type=script&lang=js&"
export * from "./VersionBugs.vue?vue&type=script&lang=js&"
import style0 from "./VersionBugs.vue?vue&type=style&index=0&id=292b52f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292b52f6",
  null
  
)

export default component.exports